// extracted by mini-css-extract-plugin
export var container = "_rs-0";
export var table = "_rs-2";
export var tableWrapper = "_rs-1";